import { useCallback } from "react";
import { DeleteForever } from "@mui/icons-material";
import { IconButton } from "@mui/material";

import newRelicErrorReport from "src/utils/newRelic/newRelicErrorReport";
import { dynamicNotification } from "src/utils/Notifications";
import getUserConfirmationPopup from "src/utils/system/DOM/getUserConfirmationPopup";
import __ from "src/utils/Translations";

import { useCompanyId } from "src/Pages/Company/CompanyContext";
import { useDeleteTotalRewardsPerk } from "src/Pages/Company/TotalReward/api/usePerks";

interface ActionProps {
  perkId: string;
}

const RowActionDeletePerk = ({ perkId }: ActionProps) => {
  const companyId = useCompanyId();

  const { mutate, isPending } = useDeleteTotalRewardsPerk(companyId);

  const deleteRow = useCallback(() => {
    mutate(perkId, {
      onSuccess() {
        dynamicNotification(__("Pomyślnie usunięto"));
      },
      onError(error) {
        dynamicNotification([
          __(
            error.message ||
              "Nie udało się usunąć benefitu. Wystąpił nieznany błąd"
          ),
        ]);
        newRelicErrorReport(
          error,
          "Pages/Company/TotalReward/Perks/RowActionDeletePerk.js - 19"
        );
      },
    });
  }, [mutate, perkId]);

  return (
    <IconButton
      title={__("Usuń")}
      color="warning"
      disabled={isPending}
      onClick={() =>
        getUserConfirmationPopup(
          __("Czy na pewno chcesz usunąć ten benefit?"),
          (confirm: boolean) => confirm && deleteRow(),
          __("Usuwanie benefitu")
        )
      }
    >
      <DeleteForever />
    </IconButton>
  );
};

export default RowActionDeletePerk;
